
const MasterData = {

    accountDetails: [
        {
            account_id: '6721c5322ef05b1b1d698e69',
            account_name: 'Turkish Wino',
            account_secret: 'tgdshe64734fgjh'
        }, {
            account_id: '6721c5a02ef05b1b1d698e73',
            account_name: ' aggregator-usd-account',
            account_secret: 'tgdshe64734fsrt'
        },
        {
            account_id: '6891e1090115dfd778a2b9da',
            account_name: 'gsc_IDR',
            account_secret: 'kpfVNV2yeIh8Md'
        },
        {
            account_id: '68abfa9fdb9afbb0d65ab0f0',
            account_name: 'gsc_IDR2',
            account_secret: 'y6N6p0jphkwSWa'
        },
        {
            account_id: '68ac0e45db9afbb0d65b4161',
            account_name: 'gsc_CNY',
            account_secret: 'UdQqUPf7d6Rbzp'
        },
        {
            account_id: '68cd21d1ab85826a5ec1dff6',
            account_name: 'gsc_VND',
            account_secret: 'ZYxkJ5v5p1ytcw'
        },
        {
            account_id: '692456a6e5a078cb719350f7',
            account_name: 'lucky_test_MKD',
            account_secret: 'NkH2RfdARCesam'
        },
        {
            account_id: '69bd251f1e1456e147e47c46',
            account_name: 'INR_TEST',
            account_secret: 'DLhKQJVjEdjmV4'
        },
        
    ],
    language: [{ value: 'en', label: 'English' }, { value: 'tr', label: 'Turkish' },]

}
export default MasterData